import { TopNavItem } from '@/types';
import { createSelector } from 'reselect';
import { actionNavConfigs } from './actions';
import { inboxNavConfigs } from './inbox';
import { withState } from '$state';
import { featureEnabled } from '$state/queries/features';

export const navConfig = createSelector(
    [actionNavConfigs, inboxNavConfigs, withState(featureEnabled, 'dentally:incoming-patients')],
    (actions, inbox, dentallyEnabled): TopNavItem[] => {
        const nav = [
            ...inbox,
            ...actions,
        ];

        if (dentallyEnabled) {
            nav.push({
                name: 'Incoming Patients',
                destination: '/dentally/patients',
                icon: 'UserPlus',
                count: 5,
            });
        }

        nav.push({
            name: 'Reporting',
            destination: '/reporting',
            icon: 'BarChart',
        }, {
            name: 'Automations',
            destination: '/automations',
            icon: 'Zap',
        });

        return nav.filter((nav) => !!nav) as TopNavItem[];
    },
);
